import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en/translation.json';
import frTranslations from './locales/fr/translation.json';
import deTranslations from './locales/de/translation.json';
import itTranslations from './locales/it/translation.json';
import esTranslations from './locales/es/translation.json';
import shallowMergeNamespaces from './locales/shallowMergeNamespaces';

import enHowLeagueWorksPage from './locales/en/bundles/howLeagueWorksPage.json';
import enRulesPage from './locales/en/bundles/rulesPage.json';
import enSeasonsPage from './locales/en/bundles/seasonsPage.json';
import enPartnerClubsPage from './locales/en/bundles/partnerClubsPage.json';
import enFindTeammatePage from './locales/en/bundles/findTeammatePage.json';
import enTermsWebsite from './locales/en/bundles/termsWebsite.json';
import enPrivacyWebsite from './locales/en/bundles/privacyWebsite.json';
import enCheckoutAndVerification from './locales/en/bundles/checkoutAndVerification.json';
import enPlayerPortalSmallerPages from './locales/en/bundles/playerPortalSmallerPages.json';
import enPlayerPortalExtended from './locales/en/bundles/playerPortalExtended.json';
import enTeamDashboard from './locales/en/bundles/teamDashboard.json';
import enAccountDeletionRequest from './locales/en/bundles/accountDeletionRequest.json';
import enPlayerLoginHelp from './locales/en/bundles/playerLoginHelp.json';
import enRegistrationUpsell from './locales/en/bundles/registrationUpsell.json';

import frHowLeagueWorksPage from './locales/fr/bundles/howLeagueWorksPage.json';
import frRulesPage from './locales/fr/bundles/rulesPage.json';
import frSeasonsPage from './locales/fr/bundles/seasonsPage.json';
import frPartnerClubsPage from './locales/fr/bundles/partnerClubsPage.json';
import frFindTeammatePage from './locales/fr/bundles/findTeammatePage.json';
import frTermsWebsite from './locales/fr/bundles/termsWebsite.json';
import frPrivacyWebsite from './locales/fr/bundles/privacyWebsite.json';
import frCheckoutAndVerification from './locales/fr/bundles/checkoutAndVerification.json';
import frPlayerPortalSmallerPages from './locales/fr/bundles/playerPortalSmallerPages.json';
import frPlayerPortalExtended from './locales/fr/bundles/playerPortalExtended.json';
import frTeamDashboard from './locales/fr/bundles/teamDashboard.json';
import frPlayerLoginHelp from './locales/fr/bundles/playerLoginHelp.json';
import frRegistrationUpsell from './locales/fr/bundles/registrationUpsell.json';

import deHowLeagueWorksPage from './locales/de/bundles/howLeagueWorksPage.json';
import deRulesPage from './locales/de/bundles/rulesPage.json';
import deSeasonsPage from './locales/de/bundles/seasonsPage.json';
import dePartnerClubsPage from './locales/de/bundles/partnerClubsPage.json';
import deFindTeammatePage from './locales/de/bundles/findTeammatePage.json';
import deTermsWebsite from './locales/de/bundles/termsWebsite.json';
import dePrivacyWebsite from './locales/de/bundles/privacyWebsite.json';
import deCheckoutAndVerification from './locales/de/bundles/checkoutAndVerification.json';
import dePlayerPortalSmallerPages from './locales/de/bundles/playerPortalSmallerPages.json';
import dePlayerPortalExtended from './locales/de/bundles/playerPortalExtended.json';
import deTeamDashboard from './locales/de/bundles/teamDashboard.json';
import dePlayerLoginHelp from './locales/de/bundles/playerLoginHelp.json';
import deRegistrationUpsell from './locales/de/bundles/registrationUpsell.json';

import itHowLeagueWorksPage from './locales/it/bundles/howLeagueWorksPage.json';
import itRulesPage from './locales/it/bundles/rulesPage.json';
import itSeasonsPage from './locales/it/bundles/seasonsPage.json';
import itPartnerClubsPage from './locales/it/bundles/partnerClubsPage.json';
import itFindTeammatePage from './locales/it/bundles/findTeammatePage.json';
import itTermsWebsite from './locales/it/bundles/termsWebsite.json';
import itPrivacyWebsite from './locales/it/bundles/privacyWebsite.json';
import itCheckoutAndVerification from './locales/it/bundles/checkoutAndVerification.json';
import itPlayerPortalSmallerPages from './locales/it/bundles/playerPortalSmallerPages.json';
import itPlayerPortalExtended from './locales/it/bundles/playerPortalExtended.json';
import itTeamDashboard from './locales/it/bundles/teamDashboard.json';
import itPlayerLoginHelp from './locales/it/bundles/playerLoginHelp.json';
import itRegistrationUpsell from './locales/it/bundles/registrationUpsell.json';

import esHowLeagueWorksPage from './locales/es/bundles/howLeagueWorksPage.json';
import esRulesPage from './locales/es/bundles/rulesPage.json';
import esSeasonsPage from './locales/es/bundles/seasonsPage.json';
import esPartnerClubsPage from './locales/es/bundles/partnerClubsPage.json';
import esFindTeammatePage from './locales/es/bundles/findTeammatePage.json';
import esTermsWebsite from './locales/es/bundles/termsWebsite.json';
import esPrivacyWebsite from './locales/es/bundles/privacyWebsite.json';
import esCheckoutAndVerification from './locales/es/bundles/checkoutAndVerification.json';
import esPlayerPortalSmallerPages from './locales/es/bundles/playerPortalSmallerPages.json';
import esPlayerPortalExtended from './locales/es/bundles/playerPortalExtended.json';
import esTeamDashboard from './locales/es/bundles/teamDashboard.json';
import esPlayerLoginHelp from './locales/es/bundles/playerLoginHelp.json';
import esRegistrationUpsell from './locales/es/bundles/registrationUpsell.json';

const resources = {
  en: {
    translation: shallowMergeNamespaces(
      enTranslations,
      enHowLeagueWorksPage,
      enRulesPage,
      enSeasonsPage,
      enPartnerClubsPage,
      enFindTeammatePage,
      enTermsWebsite,
      enPrivacyWebsite,
      enCheckoutAndVerification,
      enPlayerPortalSmallerPages,
      enPlayerPortalExtended,
      enTeamDashboard,
      enAccountDeletionRequest,
      enPlayerLoginHelp,
      enRegistrationUpsell,
    ),
  },
  fr: {
    translation: shallowMergeNamespaces(
      frTranslations,
      frHowLeagueWorksPage,
      frRulesPage,
      frSeasonsPage,
      frPartnerClubsPage,
      frFindTeammatePage,
      frTermsWebsite,
      frPrivacyWebsite,
      frCheckoutAndVerification,
      frPlayerPortalSmallerPages,
      frPlayerPortalExtended,
      frTeamDashboard,
      frPlayerLoginHelp,
      frRegistrationUpsell,
    ),
  },
  de: {
    translation: shallowMergeNamespaces(
      deTranslations,
      deHowLeagueWorksPage,
      deRulesPage,
      deSeasonsPage,
      dePartnerClubsPage,
      deFindTeammatePage,
      deTermsWebsite,
      dePrivacyWebsite,
      deCheckoutAndVerification,
      dePlayerPortalSmallerPages,
      dePlayerPortalExtended,
      deTeamDashboard,
      dePlayerLoginHelp,
      deRegistrationUpsell,
    ),
  },
  it: {
    translation: shallowMergeNamespaces(
      itTranslations,
      itHowLeagueWorksPage,
      itRulesPage,
      itSeasonsPage,
      itPartnerClubsPage,
      itFindTeammatePage,
      itTermsWebsite,
      itPrivacyWebsite,
      itCheckoutAndVerification,
      itPlayerPortalSmallerPages,
      itPlayerPortalExtended,
      itTeamDashboard,
      itPlayerLoginHelp,
      itRegistrationUpsell,
    ),
  },
  es: {
    translation: shallowMergeNamespaces(
      esTranslations,
      esHowLeagueWorksPage,
      esRulesPage,
      esSeasonsPage,
      esPartnerClubsPage,
      esFindTeammatePage,
      esTermsWebsite,
      esPrivacyWebsite,
      esCheckoutAndVerification,
      esPlayerPortalSmallerPages,
      esPlayerPortalExtended,
      esTeamDashboard,
      esPlayerLoginHelp,
      esRegistrationUpsell,
    ),
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'de', 'it', 'es'],
    debug: false,

    detection: {
      // querystring first so in-app WebViews can pass ?lng=fr (profile uiLocale).
      order: ['querystring', 'localStorage'],
      caches: ['localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
